import { defineMessages } from 'react-intl';

export default defineMessages({
  projectsPageHeader: {
    id: 'frontbucket.workspace.sections.projects.breadcrumbs',
    description: 'Text for workspace page header',
    defaultMessage: 'Projects',
  },
  projectRowHeaderTitle: {
    id: 'frontbucket.workspace.sections.projects.title',
    description: 'Text for project table header title',
    defaultMessage: 'Project',
  },
  projectRowHeaderKey: {
    id: 'frontbucket.workspace.sections.projects.key',
    description: 'Text for project table header key',
    defaultMessage: 'Key',
  },
  projectRowHeaderDescription: {
    id: 'frontbucket.workspace.sections.projects.description',
    description: 'Text for project table header description',
    defaultMessage: 'Description',
  },
  projectCreate: {
    id: 'frontbucket.workspace.sections.projects.create',
    description: 'Text for create project button',
    defaultMessage: 'Create Project',
  },
  emptyStateTitle: {
    id: 'frontbucket.workspace.sections.projects.emptyState.title',
    description:
      'Title displayed in the project list when a user does not have access to any projects',
    defaultMessage: 'No projects',
  },
  emptyStateSubtitle: {
    id: 'frontbucket.workspace.sections.projects.emptyState.subtitle',
    description:
      'Subtitle displayed in the project list when a user does not have access to any projects. Will also show link if defined',
    defaultMessage: `You don't have access to any projects.`,
  },
  createProjectLink: {
    id: 'frontbucket.workspace.sections.projects.emptyState.link',
    description:
      'Text for create project link when user does not have access to any projects',
    defaultMessage: 'Create a project',
  },
  noMatchTitle: {
    id: 'frontbucket.workspace.sections.projects.noMatch.title',
    description:
      'Title displayed in project list when no projects match filter criteria',
    defaultMessage: 'No projects match',
  },
  noMatchSubtitle: {
    id: 'frontbucket.workspace.sections.projects.noMatch.subtitle',
    description:
      'Subtitle displayed in the project list when no projects match filter criteria. Will also show link if defined',
    defaultMessage: `Try modifying or clearing your filter criteria.`,
  },
  clearAllFilters: {
    id: 'frontbucket.workspace.sections.projects.clearAllFilters',
    description: 'Link text to clear filters',
    defaultMessage: 'Clear all filters',
  },
  projectSearchFilterPlaceholder: {
    id: 'frontbucket.workspace.sections.projects.search.filter.placeholder',
    description: 'Placeholder text for search filter.',
    defaultMessage: 'Search projects',
  },
});
